import moment from 'moment';
import {
    CHANGE_CAMPAIGN_FIELD,
    CHECK_CAMPAIGN,
    RESET_CAMPAIGN_FIELDS,
    TOGGLE_CALENDAR,
    TOGGLE_LOADING,
    TOGGLE_SINGLE_BUDGET_SWITCH_BUTTON,
} from '../actions/actionTypes';

const CAMPAIGN_FIELDS = {
    END_CAMPAIGN: 'endCampaign',
    PAGE: 'page',
    START_CAMPAIGN: 'startCampaign',
};

const initialState = {
    callToAction: 'book_now',
    campaignSingleBudget: false,
    endCampaignCalendar: false,
    fieldsWithError: {},
    lifetimeBudget: null,
    loaders: {
        loadingSendCampaign: false,
    },
    page: null,
    startCampaignCalendar: false,
    text: '',
};

const validateDate = ({ rule, endDate, startDate }) => {
    if (moment(startDate).isSame(endDate)) return true;
    if (rule === 'isBefore') return endDate ? moment(startDate).isBefore(endDate) : true;
    return startDate ? moment(endDate).isAfter(startDate) : true;
};

const checkCampaign = (state, action = {}) => {
    const { fieldName } = action;

    const {
        endCampaign,
        fieldsWithError: fieldsWithErrorState,
        page,
        startCampaign,
    } = state;

    let fieldsWithError = {};

    const isStartCampaignValid = fieldName === CAMPAIGN_FIELDS.START_CAMPAIGN ? validateDate({
        endDate: endCampaign,
        startDate: startCampaign,
        rule: 'isBefore',
    }) : true;

    const isEndCampaignValid = fieldName === CAMPAIGN_FIELDS.END_CAMPAIGN ? validateDate({
        endDate: endCampaign,
        startDate: startCampaign,
        rule: 'isAfter',
    }) : true;

    const isPageValid = fieldName === CAMPAIGN_FIELDS.PAGE ? page : true;

    const isActionEmpty = !Object.keys(action).length;

    if (isActionEmpty) {
        fieldsWithError = Object.assign({}, fieldsWithError, {
            [CAMPAIGN_FIELDS.PAGE]: !state.page,
            [CAMPAIGN_FIELDS.START_CAMPAIGN]: !state.startCampaign,
        });
        return { ...state, fieldsWithError };
    }

    if (!isStartCampaignValid || !isEndCampaignValid || !isPageValid) {
        fieldsWithError = Object.assign({}, fieldsWithError, { [fieldName]: true });
        return { ...state, fieldsWithError, [fieldName]: null };
    }

    return {
        ...state,
        fieldsWithError: {
            ...fieldsWithErrorState,
            [fieldName]: false,
        },
    };
};

const changeCampaignField = (state, action) => {
    const { fieldName, value } = action;

    const newState = {
        ...state,
        [fieldName]: value,
    };

    const { fieldsWithError, ...rest } = checkCampaign(newState, action);

    if (Object.values(fieldsWithError).length > 0) return { fieldsWithError, ...rest };
    return newState;
};

const toggleLoading = (state, action) => ({
    ...state,
    loaders: {
        ...state.loaders,
        [action.name]: action.value,
    },
});

const toggleSwitchButton = state => ({
    ...state,
    campaignSingleBudget: !state.campaignSingleBudget,
});

const toggleCalendar = (state, action) => ({
    ...state,
    [action.calendarName]: !state[action.calendarName],
});

const resetCampaignFields = () => ({
    ...initialState,
});

const campaignGenericReducer = (state = initialState, action) => {
    let newState = {};
    switch (action.type) {
    case CHANGE_CAMPAIGN_FIELD: newState = changeCampaignField(state, action); break;
    case CHECK_CAMPAIGN: newState = checkCampaign(state); break;
    case RESET_CAMPAIGN_FIELDS: newState = resetCampaignFields(); break;
    case TOGGLE_CALENDAR: newState = toggleCalendar(state, action); break;
    case TOGGLE_LOADING: newState = toggleLoading(state, action); break;
    case TOGGLE_SINGLE_BUDGET_SWITCH_BUTTON: newState = toggleSwitchButton(state); break;
    default:
        newState = state;
    }
    return newState;
};

export default campaignGenericReducer;
